(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation"]) return;
  try {
    
  setTimeout(function() {
    var siteNavElement = document.getElementById("siteNav");
    
    if (siteNavElement) {
      siteNavElement.classList.remove("delayed");
    }
  }, 1000);

  } catch(e) { console.error(e); }
})();
})();
